<template>
  <a-modal
      :visible="visible"
      :closable="false"
      @cancel="visible = false"
      :footer="null"
      :width="660"
  >
    <div class="header">
      <div>推广链接</div>
    </div>
    <div  class="share-body">
      <div class="share-content">
        <div style="width:280px;height: 448px;">
          <div class="title">
            分享链接
          </div>
          <div v-if="shareData" class="content">
            {{ shareData.content }}
          </div>
          <a-spin v-else style="width: 100%;height: 100%" />
        </div>

        <a-button style="margin-top: 10px;" @click="handleCopy">
          复制口令
        </a-button>
      </div>
      <div class="share-poster">
        <div class="canvas">
          <poster v-if="shareData" ref="poster" :shareData="shareData"/>
        </div>

        <a-button @click="saveImage" style="margin-top: 10px;">
          保存图片
        </a-button>
      </div>
    </div>

  </a-modal>
</template>

<script>
import {fetchGoodsShare} from "@/api/goods-list";
import Poster from "@/components/zy-share-dialog/poster.vue";
import {setClipboardData} from "./utils";

export default {
  name: "index",
  components: {Poster},
  data() {
    return {
      visible: false,
      shareData: undefined,
      goods: undefined,
    }
  },
  beforeMount() {
  },
  methods: {
    show(goods) {
      const { good_id, commission, provider} = goods
      this.goods = goods
      this.visible = true
      this.formData = {
        gid: good_id,
        type: provider,
        commission
      }
      this.shareData = undefined
      this.fetchData()
    },
    fetchData() {
      fetchGoodsShare(this.formData).then(res => {
        console.log(res)
        this.shareData = res
      })
    },
    saveImage() {
      console.log(this.$refs.poster)
      this.$refs.poster.saveImage()

    },
    handleCopy() {
      setClipboardData(this.shareData.content).then(() => {
        this.$message.success('复制成功');
      })
    }

  }
}
</script>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  font-weight: 500;
  color: #000000;
  line-height: 22px;
}

.share-body {

  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  .share-content {
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      font-size: 14px;
      font-weight: 500;
      color: #000000;
      line-height: 20px;
      text-align: center;
    }

    .content {
      font-size: 14px;
      font-weight: 500;
      color: #858585;
      line-height: 20px;
      white-space: pre-wrap;
      word-wrap: break-word;
      margin-top: 36px;
      margin-bottom: 20px;
      height: 360px;
    }

    .button {

    }
  }

  .share-poster {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    .canvas {
      //position: absolute;
      //left: 0;
      //top: 0;
      position: relative;
      width: 280px;
      height: 448px;
    }
  }
}
</style>
